// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.3.0';
export const APP_NAME = 'markwins';
export const FILE_HASH = '1773846842855';
export const BUILD_DATE = '2026-03-18T15:14:02.855Z';
/* tslint:enable */
